import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { rem } from 'polished';
import uniqueId from 'lodash.uniqueid';

const Wrapper = styled.div`
  width: 100%;
  margin-bottom: ${rem(20)};
  > label {
    margin-bottom: ${rem(10)};
  }
`;

class FormGroup extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      uniqueId: uniqueId(),
    };
  }

  getChildContext() {
    return { id: this.state.uniqueId };
  }

  render() {
    const { children } = this.props;
    return <Wrapper>{children}</Wrapper>;
  }
}

FormGroup.childContextTypes = {
  id: PropTypes.string.isRequired,
};

FormGroup.propTypes = {
  children: PropTypes.node.isRequired,
};

FormGroup.defaultProps = {};

export default FormGroup;



// WEBPACK FOOTER //
// ./src/components/FormGroup/index.js